// extracted by mini-css-extract-plugin
export default {"container":"InventorySheetSummary_container__aB4Yk"};